const DELIMITER = '|';

const DEFAULT_ENVELOPE_BLOCK = {
  event_template_id: '168',
  event_template_version_id: '1',
  event_type_version_id: '1',
} as const;

const LISTING_STATUSES = {
  ACTIVE: 'active_listing',
  OFF_MARKET: 'off_market_listing',
};

const TRIGGER_TYPE = {
  IMPRESSION: 'impression',
  INTERACTION: 'interaction',
};

const TRIGGER_OBJECT = {
  FINANCIAL_EXPECTATIONS_PAGE: 'financial_expectations_page',
  NO_TRIGGER_OBJECT: 'no_trigger_object',
  PET_POLICY_PAGE: 'pet_policy_page',
  // post activation review
  REVIEW: 'review',
} as const;

const TRIGGER_LOCATIONS = {
  POST_ACTIVATION: 'post_activation',
  POSTING_PATH: 'posting_path',
  POSTING_PATH_REVIEW: 'posting_path_review',
  NEXT_STEPS_APPS: 'zrm_next_steps_apps',
  APPS_TAB_ENABLE_APPS: 'appstab_enableapps',
  OVERVIEW_TAB_ENABLE_APPS: 'overviewtab_enableapps',
  PROPERTY_OVERVIEW: 'zrm_property_overview',
  IRENE_APPLICATIONS_DASHBOARD: 'irene_applications_dashboard',
} as const;

export { DEFAULT_ENVELOPE_BLOCK, DELIMITER, LISTING_STATUSES, TRIGGER_LOCATIONS, TRIGGER_OBJECT, TRIGGER_TYPE };
